import axios, { InternalAxiosRequestConfig } from "axios";
import { useAuth } from '@/composables/useAuth'

const appwriteApiUrl = import.meta.env.VITE_API_URL
const awsApiGatewayUrl = import.meta.env.VITE_API_GATEWAY_URL

const defaultConfig = {
	headers: {
		"Content-Type": "application/json",
	},
	withCredentials: true,
}
const requestMiddleware = async (config: InternalAxiosRequestConfig): Promise<any> => {
	const { jwt } = useAuth()
	if (!jwt.value) return config;

	config.headers.Authorization = `Bearer ${jwt.value}`;
	return config;
}

const customInstance = axios.create({
	baseURL: appwriteApiUrl,
	...defaultConfig,
});
export const customInstanceAWS = axios.create({...defaultConfig, baseURL: awsApiGatewayUrl})

customInstanceAWS.interceptors.request.use(requestMiddleware)
customInstance.interceptors.request.use(requestMiddleware);

export default customInstance;
